import React from 'react'
import { Box, CircularProgress } from '@mui/material'

export const renderLoading = () => (
  <Box display="flex" width="100%" justifyContent="center" alignItems="center">
    <CircularProgress size={40} />
  </Box>
)
